<template>
  <button v-if="pageIsNotDashboard" class="cursor-pointer text-slate-white my-2" @click.prevent="dashboard()">Dashboard</button>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { useRoute, useRouter } from 'vue-router'

  import useWallStore from '@/composables/wallStore'
  import { useNoteStore } from '@/composables/noteStore'
  import { useUserStore } from '@/composables/userStore'

  const wallStore = useWallStore()
  const noteStore = useNoteStore()
  const userStore = useUserStore()
  const router = useRouter()
  const route = useRoute()

  const pageIsNotDashboard = computed(() => {
    const user = userStore.getters.user.value
    let userValue = user ? user.status.isRegistered : false
    return !route.fullPath.includes('dashboard') && userValue
  })

  function dashboard() {
    wallStore.actions.reset()
    noteStore.actions.clearNotes()
    router.push('/dashboard')
  }
</script>

<style scoped></style>
